if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
  this.initializeProductSwapUtility();

 /* const variantScript = document.getElementById('product-variants-json');
  if (variantScript) {
    try {
      this.variants = JSON.parse(variantScript.textContent);
    } catch (e) {
      console.error('Failed to parse variants JSON:', e);
      this.variants = [];
    }
  } else {
    this.variants = [];
  }
        console.log('[AutoSelect] Loaded variants:', this.variants);*/

    const variantScript = document.getElementById('product-variants-json');
if (variantScript) {
  try {
    const parsed = JSON.parse(variantScript.textContent);

// HARDCODE the number of expected options:
const expectedOptionsCount = 3;

this.variants = parsed.map(v => {
  const options = typeof v.title === 'string'
    ? v.title.split(' / ').slice(0, expectedOptionsCount)
    : [];

  return {
    ...v,
    options
  };
});

console.log('[AutoSelect] Patched variants with options:', this.variants);
  } catch (e) {
    console.error('Failed to parse or patch variants JSON:', e);
    this.variants = [];
  }
} else {
  this.variants = [];
}

if (Array.isArray(this.variants) && this.variants.length > 0) {
  const expectedOptionsCount = 3;
  this.variants = this.variants.map(v => {
    const options = typeof v.title === 'string'
      ? v.title.split(' / ').slice(0, expectedOptionsCount)
      : [];
    return { ...v, options };
  });
  console.log('[AutoSelect] Rewritten variants with .options[]:', this.variants);
}

        


  this.onVariantChangeUnsubscriber = subscribe(
    PUB_SUB_EVENTS.optionValueSelectionChange,
    this.handleOptionValueChange.bind(this)
  );

  this.initQuantityHandlers();

  const variant = this.getSelectedVariant(this);
  this.updateInventoryMessage(variant);
  this.updateBtnPrice(variant, this.getCurrentQuantity());
  this.updateInfoStats(variant);
  if (variant?.option1) {
  this.injectVariantLabelText(variant.option1);
}

  document.dispatchEvent(new CustomEvent('shopify:variant:changed', {
    bubbles: true,
    detail: { variantId: variant?.id, variant }
  }));

  this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
}


      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        this.quantityInput.addEventListener('change', () => {
          const variant = this.getSelectedVariant(this);
          this.updateBtnPrice(variant, this.getCurrentQuantity());
        });
        this.quantityInput.addEventListener('input', () => {
          const variant = this.getSelectedVariant(this);
          this.updateBtnPrice(variant, this.getCurrentQuantity());
        });
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      getCurrentQuantity() {
        const qty = parseInt(this.quantityInput?.value, 10);
        return Number.isNaN(qty) || qty < 1 ? 1 : qty;
      }

      updateBtnPrice(variant, quantity = 1) {
        const btnPrice = this.querySelector('.btnPrice');
        if (!btnPrice || !variant?.price) return;

        const moneyFormat = btnPrice.dataset.moneyFormat || window.Shopify?.money_format;
        const total = variant.price * quantity;
        const formatted = window.Shopify?.formatMoney
          ? window.Shopify.formatMoney(total, moneyFormat)
          : (total / 100).toFixed(2);

        btnPrice.textContent = formatted;
        btnPrice.dataset.price = variant.price;
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
        
        // Inside handleOptionValueChange
        this.wasUserVariantClick = event?.isTrusted === true;
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

        injectVariantLabelText(variantValue) {
  console.log('[Debug] injectVariantLabelText called with:', variantValue);

  const fieldset = this.querySelector('fieldset.js.product-form__input.product-form__input--pill.Diameter');
  console.log('[Debug] Fieldset found:', fieldset);

  if (!fieldset) return;

  const labelContainer = fieldset.querySelector('legend.form__label');
  console.log('[Debug] Label container found:', labelContainer);

  if (!labelContainer) return;

  let target = labelContainer.querySelector('.text_dia');
  console.log('[Debug] .text_dia found:', target);

  if (!target) {
    target = document.createElement('span');
    target.classList.add('text_dia');
    labelContainer.appendChild(target);
    console.log('[Debug] .text_dia created');
  }

  const old = target.querySelector('.dia_text');
  if (old) {
    old.remove();
    console.log('[Debug] Removed old .dia_text');
  }

  const labelMap = {
    '1/2"': 'For 4-Wheelers/Snowmobiles',
    '5/8"': 'For SXS/UTV',
    '3/4"': 'For Small Crossover SUVs',
    '7/8"': 'For Large SUVs/Small Pickups (Tacomas, F-150 etc)',
    '1"': 'For 1-Ton/Full Size Pickups',
    '1-1/4"': 'For Overland Vans / Utility Trucks',
    '1-1/2"': 'For Utility Trucks/Small Heavy Equip',
    '2"': 'For Tractors/Class 7-8 Vehicles',
    '2-1/2"': 'For Large Tractors/Heavy Machinery'
  };

  const text = labelMap[variantValue];
  console.log('[Debug] Mapped label:', text);

  if (!text) return;

  const span = document.createElement('span');
  span.classList.add('dia_text');
  span.textContent = `${variantValue} - ${text}`;
  target.appendChild(span);
  console.log('[Debug] Appended span:', span);
}

      updateSaveBadge(variant) {
        const priceEl = this.querySelector('.price');
        if (!priceEl) return;

        let badge = priceEl.querySelector('.price__save-badge');

        if (variant?.compare_at_price && variant.compare_at_price > variant.price) {
          const saveAmount = variant.compare_at_price - variant.price;
          const moneyFormat = window.Shopify?.money_format;
          const formatted = window.Shopify?.formatMoney
            ? window.Shopify.formatMoney(saveAmount, moneyFormat)
            : '$' + (saveAmount / 100).toFixed(2);

          if (!badge) {
            // Badge was wiped by the section fetch — recreate it
            badge = document.createElement('span');
            badge.className = 'price__save-badge';
            priceEl.appendChild(badge);
          }
          badge.textContent = 'Save ' + formatted;
          badge.style.display = '';
        } else if (badge) {
          // No discount on this variant — hide the badge
          badge.style.display = 'none';
        }
      }

      updateInfoStats(variant) {
        if (!variant?.id) return;

        const statsEl = this.querySelector('.product-info-stats');
        if (!statsEl) return;

        const dataEl = document.getElementById('variant-features-json');
        if (!dataEl) return;

        let featuresMap;
        try {
          featuresMap = JSON.parse(dataEl.textContent);
        } catch (e) {
          console.error('[InfoStats] Failed to parse variant-features-json:', e);
          return;
        }

        const data = featuresMap[variant.id];
        // If no metaobject is assigned to this variant, leave the block as-is
        if (!data) return;

        const items = statsEl.querySelectorAll('.product-info-stats__item');
        const values = [data.capacity, data.strength, data.length];

        values.forEach((value, i) => {
          const item = items[i];
          if (!item || value == null) return;
          const valueEl = item.querySelector('.product-info-stats__value');
          if (valueEl) valueEl.textContent = value;
        });
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
this.updateInventoryMessage(variant);
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          /*if (!variant) {
            this.setUnavailable();
            return;
          }*/
          const variantIdInput = html.querySelector('input[name="id"]');
const isValid = !!(variant && variantIdInput?.value);

if (!isValid) {
  console.warn('[AutoSelect] Variant resolution failed. Triggering fallback...');
  this.runFallbackSelection();
  return;
}


          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          this.updateBtnPrice(variant, this.getCurrentQuantity());
          this.updateSaveBadge(variant);
          this.updateInfoStats(variant);

            console.log('yesyesold');
          if (variant?.option1) {
            console.log('yesyes');
  console.log('[Debug] Calling injectVariantLabelText with:', variant.option1);
  this.injectVariantLabelText(variant.option1);
          }

          if (this.wasUserVariantClick) {
            console.log(this.wasUserVariantClick);
            var tabButtons = document.getElementsByClassName('tab-buttons');
            if (tabButtons.length > 0) {
              console.log(variant.option1);
              const buttons = document.querySelectorAll('.tab-buttons button');
              buttons.forEach((button) => {
                if (button.textContent.trim() === variant.option1) {
                  console.log(`Clicking tab for: ${variant.option1}`);
                  button.click();
                }
              });
            }
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
          const customTextEl = document.getElementById('custom-add-to-cart-text');
if (customTextEl) {
  const customText = customTextEl.dataset.text;
  console.log(customText);
  const addToCartBtn = this.querySelector(`#ProductSubmitButton-${this.sectionId}`);
  const addToCartText = addToCartBtn?.querySelector('.product-form__submit-text') || addToCartBtn;
  if (addToCartText && addToCartText.textContent !== customText) {
    addToCartText.textContent = customText;
  }
}
          document.dispatchEvent(new CustomEvent('shopify:variant:changed', {
            bubbles: true,
            detail: { variantId: variant?.id, variant }
          }));
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        //window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);

const currentUrl = new URL(window.location.href);

if (this.dataset.url) currentUrl.pathname = this.dataset.url;

currentUrl.searchParams.set('variant', variantId);

window.history.replaceState({}, '', currentUrl.toString());
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      
     /* updateInventoryMessage(variant) {
  const container = this.querySelector('.variant-inventory-message');
  if (!container || !variant) return;

  console.log('[Debug] Incoming variant:', variant);
  console.log('[Debug] Available variants:', this.variants);

  if (!this.variants?.length) {
    console.warn('No variants loaded yet.');
    return;
  }
        const variantScript = document.getElementById('product-variants-json');
if (variantScript) {
  try {
    this.variants = JSON.parse(variantScript.textContent);
  } catch (e) {
    console.error('Could not parse variants JSON:', e);
    this.variants = [];
  }
}


  const realVariant = this.variants.find(v => Number(v.id) === Number(variant.id));

  if (!realVariant || typeof realVariant.inventory_quantity !== 'number') {
    console.warn('Inventory data missing for variant:', variant.id, realVariant);
    container.textContent = '';
    return;
  }

  const qty = realVariant.inventory_quantity;
  const lowStockThreshold = 2;

  if (qty > lowStockThreshold) {
    container.textContent = 'In Stock';
    container.style.color = 'black';
  } else if (qty > 0) {
    container.textContent = `Only ${qty} Left`;
    container.style.color = 'green';
  } else {
    container.textContent = 'Ships in 7-14 Business Days';
    container.style.color = 'red';
  }
}*/

      updateInventoryMessage(variant) {
  const container = this.querySelector('.variant-inventory-message');
  if (!container) return;

  // Fallback to default variant if none passed
  if (!variant) {
    const defaultVariantId = this.querySelector('input[name="id"]')?.value;
    if (defaultVariantId) {
      variant = { id: defaultVariantId };
    } else {
      console.warn('[Inventory] No variant or ID found.');
      return;
    }
  }
  const variantScript = document.getElementById('product-variants-json');
  if (variantScript) {
    try {
      this.variants = JSON.parse(variantScript.textContent);
    } catch (e) {
      console.error('Could not parse variants JSON:', e);
      this.variants = [];
    }
  }

  const realVariant = this.variants.find(v => Number(v.id) === Number(variant.id));

  if (!realVariant || typeof realVariant.inventory_quantity !== 'number') {
    console.warn('Inventory data missing for variant:', variant.id, realVariant);
    container.textContent = '';
    return;
  }

  const qty = realVariant.inventory_quantity;
  const lowStockThreshold = 2;

  if (qty > lowStockThreshold) {
    container.textContent = 'In Stock';
    container.style.color = 'black';
  } else if (qty > 0) {
    container.textContent = `Only ${qty} Left`;
    container.style.color = 'green';
  } else {
    container.textContent = 'Ships in 7-14 Business Days';
    container.style.color = 'red';
  }

}



      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }






      runFallbackSelection() {
const allVariants = this.variants ?? []; // 👈️ Force-use patched variants
  const optionGroups = this.variantSelectors?.querySelectorAll('fieldset');
  if (!optionGroups || optionGroups.length === 0) return;

  const currentSelections = Array.from(optionGroups).map((group) => {
    const checked = group.querySelector('input[type="radio"]:checked');
    return checked?.value || null;
  });
        console.log('[AutoSelect] Current selections:', currentSelections);
console.log('[AutoSelect] All available variants:', allVariants);

  const isValidSelection = allVariants.some((variant) =>
  variant.available &&
  Array.isArray(variant.options) &&
  variant.options.every((opt, idx) => opt === currentSelections[idx])
);


  if (isValidSelection) {
    console.log('[AutoSelect] Valid variant selected. Skipping fallback.');
    return;
  }

let bestScore = -1;
let fallbackVariant = null;

console.log('[AutoSelect] Patched variants for scoring:', allVariants);

for (const variant of allVariants) {
  if (!variant.available) continue;

  // Force-rebuild options[] from title if not already present
  if (!Array.isArray(variant.options)) {
    const titleParts = typeof variant.title === 'string' ? variant.title.split(' / ') : [];
    variant.options = titleParts;
    console.log('[AutoSelect] Reconstructed .options[] for variant:', variant);
  }

  console.log('[AutoSelect] Evaluating variant:', variant);

  let score = 0;

  // ❌ BAD: This was the problem
  // if (fallback.options[0] !== currentSelections[0]) continue;

  // ✅ FIXED: use variant instead of fallback
  if (variant.options[0] !== currentSelections[0]) continue;
  if (variant.options[1] === currentSelections[1]) score++;
  if (variant.options[2] === currentSelections[2]) score++;

  if (score > bestScore) {
    bestScore = score;
    fallbackVariant = variant;
  }
}


        
        console.log('[AutoSelect] Best score found:', bestScore);
console.log('[AutoSelect] Fallback variant selected:', fallbackVariant);



  if (!fallbackVariant) {
    console.warn('[AutoSelect] No fallback variant available.');
    this.setUnavailable();
    return;
  }
        console.log('[AutoSelect] Best match fallback variant found:', fallbackVariant);


  fallbackVariant.options.forEach((optValue, idx) => {
    const group = optionGroups[idx];
    if (!group) return;

    const safeValue = CSS.escape(optValue);
    const input = group.querySelector(`input[type="radio"][value="${safeValue}"]`);
    if (input && !input.checked) {
      setTimeout(() => {
  console.log(`[AutoSelect] Clicking input for option[${idx}]:`, optValue);
  const clickEvent = new PointerEvent('click', {
    bubbles: true,
    cancelable: true,
    composed: true,
  });
  input.dispatchEvent(clickEvent);
}, 30);

     
    }
  });
}




      
    }
  );
}
